<p-dialog
    appDialogoPadrao="pi pi-wallet"
    descricao="Conta corrente vinculada ao banco."
    [(visible)]="showDialog"
    [header]="conta() ? 'Editar Conta' : 'Nova Conta'"
    [breakpoints]="{ '960px': '75vw', '640px': '90vw' }"
    [style]="{ width: '450px' }"
    (onShow)="onDialogShow()"
>
    <form [formGroup]="contaForm" (ngSubmit)="salvar()" class="flex flex-col gap-4 pt-2">
        <div class="flex flex-col gap-2">
            <label for="agencia" class="font-medium">Nº Agência <span class="text-red-500">*</span></label>
            <div class="flex gap-2">
                <input pInputText id="agencia" formControlName="agencia" class="w-full" [class.ng-invalid]="isInvalid('agencia')" [class.ng-dirty]="isInvalid('agencia')" placeholder="0000" />
                <div class="flex flex-col gap-2 w-20">
                    <input pInputText id="agenciaDv" formControlName="agenciaDv" class="w-full text-center" placeholder="DV" maxlength="1" />
                </div>
            </div>
            <p-message *ngIf="isInvalid('agencia')" severity="error" variant="simple">Agência é obrigatória</p-message>
        </div>

        <div class="flex flex-col gap-2">
            <label for="conta" class="font-medium">Nº Conta <span class="text-red-500">*</span></label>
            <div class="flex gap-2">
                <input pInputText id="conta" formControlName="conta" class="w-full" [class.ng-invalid]="isInvalid('conta')" [class.ng-dirty]="isInvalid('conta')" placeholder="00000000" />
                <div class="flex flex-col gap-2 w-20">
                    <input pInputText id="contaDv" formControlName="contaDv" class="w-full text-center" placeholder="DV" maxlength="1" />
                </div>
            </div>
            <p-message *ngIf="isInvalid('conta')" severity="error" variant="simple">Conta é obrigatória</p-message>
        </div>

        <div class="flex items-center gap-3 py-2">
            <p-toggleswitch formControlName="compartilhada" inputId="compartilhada"></p-toggleswitch>
            <label for="compartilhada" class="font-medium cursor-pointer">Conta Compartilhada</label>
        </div>

        <div class="flex flex-col gap-2">
            <label for="finalidade" class="font-medium">Finalidade</label>
            <input pInputText id="finalidade" formControlName="finalidade" class="w-full" placeholder="Ex: Arrecadação de Anuidades" />
        </div>

        <div class="flex justify-end gap-2 mt-4">
            <p-button label="Cancelar" icon="pi pi-times" [text]="true" severity="secondary" (click)="hideDialog()" />
            <p-button label="Salvar" icon="pi pi-check" type="submit" [appCan]="roleBancosEditar" />
        </div>
    </form>
</p-dialog>
